import { createAction } from 'redux-actions'

export const openAlertOwnerModal = createAction('OPEN_ALERT_OWNER_MODAL')
export const closeAlertOwnerModal = createAction('CLOSE_ALERT_OWNER_MODAL')
